//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Rule.js";
import "../no/NXObject.js";
let d=[[[0,"Description",1,0],[0,"RuleName",1,0]],[[["startNode","fromPort","endNode","toPort"],"ConnectNode",{R_:{connector:"Rule.Connector"}},4,0],[["applicationName","objectName"],"CreateNode",{R_:{ruleNode:"Rule.Node"}},2,0],[["snippetRuleFile"],"CreateSnippetNode",{R_:{ruleNode:"Rule.Node"}},1,0],[[],"CreateNode1",{},0,0],[["password"],"SetPassword",{},1,0],[["password"],"Unlock",{},1,0],[[],"Lock",{},0,0],[[],"GetLibraryRulePath",{R_:{libraryRulePath:''}},0,0],[[],"RemoveLibraryLink",{},0,0],[["startNode","fromPort","endNode","toPort"],"ReplaceConnection",{},4,0]],[["RuleNodeCollection","Rule.NodeCollection",0]]];
SPLM.Rule.RuleObject = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Rule.RuleObject";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;